import { Navigate } from "react-router-dom";
import LoadingScreen from "../components/loading-screen";
import { useAuthContext } from "../auth/useAuthContext";
import { PATH_DASHBOARD } from "./paths";
import VideoLandingPage from "../pages/landing";

/**
 * Marketing root for the primary domain only.
 * Authenticated users are sent to the app; guests see the landing page.
 */
export default function PublicRootRoute() {
  const { isAuthenticated, isInitialized } = useAuthContext();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to={PATH_DASHBOARD.diary.root} replace />;
  }

  return <VideoLandingPage />;
}
